import { render, staticRenderFns } from "./registrationactivity.vue?vue&type=template&id=3b86f3a8&scoped=true"
import script from "./registrationactivity.vue?vue&type=script&lang=js"
export * from "./registrationactivity.vue?vue&type=script&lang=js"
import style0 from "./registrationactivity.vue?vue&type=style&index=0&id=3b86f3a8&prod&scoped=true&lang=scss"
import style1 from "./registrationactivity.vue?vue&type=style&index=1&id=3b86f3a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86f3a8",
  null
  
)

export default component.exports